import { PureComponent } from 'react';
import PropTypes from 'prop-types';

class CardHighlight extends PureComponent {

  componentDidMount() {
    setTimeout(() => {
      this.forceUpdate();
    }, 200);
  }

  render() {
    const target = document.querySelector(this.props.selector);

    if (!target) {
      return null;
    }

    const styles = {
      left: target.offsetLeft,
      top: target.offsetTop,
      width: target.offsetWidth,
      height: target.offsetHeight
    };

    return (
      <span className="t-card-highlight" style={styles} />
    );
  }
}

CardHighlight.propsTypes = {
  selector: PropTypes.string.isRequired
};

export default CardHighlight;